import Repository from '@/repositories/repository'

const DemoRegRepository = {
  async getDemoReg(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('demo-registration', 'page', params)
  }
}

export default DemoRegRepository
